import uuid from 'uuid';

// eslint-disable-next-line import/prefer-default-export
export function generateRandomString() {
  return uuid.v4();
}
